// x = 5000..7500 -> 2500 -> 5000

export const COMMENT_BOX_OPENED_EVENT = 'akaire:comment-box-opened';

export function createCommentBoxSyncId(prefix = 'comment-box') {
  return `${prefix}-${Date.now()}-${Math.random().toString(36).slice(2)}`;
}

export function announceCommentBoxOpened(sourceId) {
  document.dispatchEvent(
    new CustomEvent(COMMENT_BOX_OPENED_EVENT, {
      detail: { sourceId },
    })
  );
}

export function positionStyle({ x, y, width, height, commentBox = false }) {
  const maxMarker = 10000;
  let maxPercent = 5;
  const imageElement = document.getElementById('animation-image');
  if(commentBox){
    var isOverX = true;
    var isOverY = true;
    var overY = y;
    var overX = 2400;
    if($('#show-compare-version-akaire').length) overX = 1500;
    if(window.innerWidth < 1550) overX = 1000;

    const isNarrowImage = imageElement ? imageElement.offsetHeight < 410 : false;
    
    if (isNarrowImage) {
      maxPercent = 10;
      if (y > maxMarker * 0.6) {
        overY = y - 1000;
        isOverY = true;
      }
    } else {
      if (y > maxMarker * 0.65) {
        overY = maxMarker - y;
        isOverY = false;
      }
    }

    if (y > maxMarker * 0.1) {
      setTimeout(function(){
        const element = document.getElementById('btn-submit-comment-box');
        if (element) {
          element.scrollIntoViewIfNeeded();
        }
      }, 500);
    }
  }else{
    var isOverX = (x + width) < 6000;
    var isOverY = (y + height) < 5000;
    var overX, overY;
    overY = (isOverY ? y + height : maxMarker - y)
    overX = (isOverX ? x + width : maxMarker - x)
    if (width > 3000 && !isOverX) {
      if(overX > maxMarker * 0.9) {
        overX = x + (maxMarker * 0.1);
      }else{
        overX = x;
      }
      isOverX = true;
    }
    if (height > 2500 && !isOverY) {
      overY = y + height;
      isOverY = true;
      if (overY > maxMarker * 0.5){
        overY = maxMarker - overY
        isOverY = false
      }
    }
  }

  const largeImage = imageElement ? imageElement.offsetHeight > 1000 : false;
  const tinyImage = imageElement ? imageElement.offsetHeight < 210 : false;

  if (largeImage) {
    maxPercent = Math.min(10, (50 / imageElement.offsetHeight) * 100);
  }
  if (tinyImage) {
    maxPercent = (150 / imageElement.offsetHeight) * 100;
  }
  return {
    [isOverX ? 'left' : 'right']: `${overX / 100}%`,
    [isOverY ? 'top' : 'bottom']: `${Math.max((overY / 100), maxPercent)}%`,
  };
};
